<template>
  <span>
    <Spinner />
    <div class="animate__animated animate__fadeInLeft animate__faster">
    <div class="app__title bg-dark--custom pt-4">
      <h2 class="m-0 text-center" style="color: white">Asegura tu auto</h2>
      <div class="container">
        <p class="app__subtitle text-center mt-3 pt-1">{{ name }}</p>
      </div>
    </div>

    <main class="app__main mt-0">
      <div class="container">
        <div class="app__profile__pic m-auto">
          <img
            :src="profilePic"
            alt=""
            style="width: 100%; height: 100%"
          />
        </div>
        <div class="card-body--custom mt-3 animate__animated animate__fadeIn" v-if="!ver.active">
          <h5 class="mb-3">Mis autos</h5>
          <div class="alert alert-danger text-center m-0 col-12" v-if="autos.length === 0">Aún no tienes autos dados de alta</div>
          <div
            class="
              d-flex
              flex-wrap
              justify-content-around
              card__auto__container
            "
          >
            <div
              class="card"
              v-on:click="handleStep(i)"
              v-for="(auto, i) in autos"
              v-bind:key="i"
            >
              <div class="card__img__container">
                <img
                  class="card-img-top"
                  :src="auto.FotoVehiculo"
                  alt="Card image cap"
                />
              </div>
              <div class="card-body p-2">
                <h6>{{ auto.marca }} {{ auto.modelo }}</h6>
                <p class="card-text">
                  Póliza: <span class="badge badge-dark">{{ auto.NumeroPoliza }}</span>
                </p>
                <p class="card-text">
                  Caducidad: <span class="badge badge-success">{{ auto.VigenciaFinalPoliza }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="relative no-abs animate__animated animate__fadeIn" v-if="ver.active">
          <a class="btn-prev" @click="handleBack"
            ><i class="fas fa-arrow-left"></i
          ></a>
          <div class="card-body--custom mt-1">
            <div class="d-flex flex-wrap align-items-stretch mt-5">
              <div class="card col-6 p-0 m-0">
                <div class="card__img__container">
                  <div v-if="uploadImage" class=" animate__animated animate__fadeIn">
                    <ImageUpload
                      v-on:upload="handleUploadImage"
                      v-on:cancel="handleCancelUpload"
                      v-if="replaceImage === 1 || replaceImage === 0"
                    />
                    <small
                      class="text-center d-block text-secondary"
                      v-if="replaceImage === 0"
                      >Ó</small
                    >
                    <span v-if="replaceImage === 2 || replaceImage === 0">
                      <Photo 
                        ref="photo"
                        v-if="takePhoto"
                        @shot="handleShot"
                      />
                      <div class="d-flex justify-content-center mt-3 mb-3">
                        <button
                          class="btn btn-sm btn-primary--custom"
                          style="max-width: 200px"
                          @click="handleCam"
                          v-if="!takePhoto"
                        >
                          <i class="fas fa-camera"></i> Toma una foto
                        </button>
                        <button
                          class="btn btn-danger"
                          v-if="takePhoto"
                          @click="handleCancelReplacement"
                        >
                          Cancelar
                        </button>
                        <button
                          class="btn btn-sm btn-primary--custom ml-1"
                          style="max-width: 200px"
                          @click="shotAgain"
                          v-if="mySnap && takePhoto"
                        >
                          <i class="fas fa-camera"></i> Tomar otra
                        </button>
                      </div>
                    </span>
                  </div>

                  <img
                    class="card-img-top"
                    src="https://i.pinimg.com/originals/13/40/61/1340611e590982e5b775c6f0feca16bd.jpg"
                    alt="Card image cap"
                    v-if="!uploadImage"
                  />
                </div>
                <div class="d-flex justify-content-end p-1">
                  <button
                    class="btn btn-sm btn-warning mb-0 flex-grow-1"
                    v-on:click="uploadImage = true"
                    v-if="!uploadImage"
                  >
                    <i class="fas fa-camera"></i> Cambiar imágen
                  </button>



                  <span v-if="mySnap">
                    <button class="btn btn-sm btn-success" v-if="uploadImage">
                      Guardar
                    </button>
                  </span>
                </div>
              </div>

              <div
                class="
                  col-6
                  d-flex
                  flex-column
                  justify-content-between
                  pt-3
                  pb-1
                "
              >
                <div>
                  <p class="card-text mb-1">
                    <b>Marca:</b> {{ ver.auto.marca }}
                  </p>
                  <p class="card-text mb-1">
                    <b>Modelo:</b> {{ ver.auto.modelo }}
                  </p>
                  <p class="card-text mb-1"><b>Año:</b> 68</p>
                </div>
                <button class="btn btn-sm btn-outline-info mt-3">
                  <i class="fas fa-file-contract"></i> Consultar póliza
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
  <Navigation />
  </span>
</template>

<script>
import ImageUpload from "../../componentes/tools/Image.vue";
import Photo from '../../componentes/WebCam/Photo.vue'
import Navigation from '../../componentes/Navbar.vue'
import Spinner from '../../componentes/Spinner'

export default {
  data: function () {
    return {
      autos: [],
      ver: { auto: Object, active: false },
      replaceImage: 0, // 0:None, 1:Drag, 2:Snap
      name: "",

      profilePic: this.$store.state.userData.rutafotoperfil,

      uploadImage: false,
      takePhoto: false,
      mySnap: false,
    };
  },
  props: {
    // autos: Array,
  },
  components: {
    ImageUpload,
    Photo,
    Navigation,
    Spinner
  },
  methods: {
    handleStep(step) {
      this.ver.auto = this.autos[step];
      this.ver.active = true;
    },
    handleUploadImage(base64) {
      this.replaceImage = 1;
      this.mySnap = base64;
    },
    handleCancelUpload() {
      this.handleCancelReplacement();
    },
    handleBack() {
      this.mySnap = false;
      this.takePhoto = false;
      this.replaceImage = 0;
      this.ver.active = false;
      this.uploadImage = false;
    },
    handleCam() {
      this.takePhoto = true;
      this.replaceImage = 2;
    },
    shotAgain() {
      this.mySnap = null;
      this.$refs.photo.onStart();
    },
    handleShot(base64) {
      this.mySnap = base64;
    },
    handleCamError() {
      this.handleCancelReplacement();
    },
    handleCancelReplacement() {
      this.mySnap = false;
      this.takePhoto = false;
      this.replaceImage = 0;
      this.$refs.photo.onStop();
    }
  },
  mounted() {
    this.autos = this.$store.state.autos;
    const { nombre, apaterno, amaterno } = this.$store.state.userData;
    this.name = `${nombre} ${apaterno} ${amaterno}`;
  
    if (this.$store.state.autos) {
      this.autos = this.$store.state.autos;
      console.log( this.autos );
    }
  },
};
</script>